import script from "./changePasswordModel.vue?vue&type=script&setup=true&lang=js"
export * from "./changePasswordModel.vue?vue&type=script&setup=true&lang=js"

import "./changePasswordModel.vue?vue&type=style&index=0&id=197d3f43&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197d3f43"]])

export default __exports__